import {
  clearLazyRouteRecoveryAttempt,
} from '@/utils/lazyRouteWithRecovery.jsx';
import { useTranslation } from '@/components/i18n/TranslationProvider';

export default function LazyRouteRecoveryFallback({ recoveryKey }) {
  const { t } = useTranslation();

  const handleReload = () => {
    clearLazyRouteRecoveryAttempt(recoveryKey);
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  return (
    <div className="flex min-h-[40vh] items-center justify-center px-4">
      <div className="w-full max-w-lg rounded-2xl border border-white/10 bg-white/5 p-6 text-center text-sm text-slate-200 shadow-2xl shadow-black/20 backdrop-blur">
        <p className="text-base font-semibold text-white">
          {t('routing.recovery.title')}
        </p>
        <p className="mt-2 text-sm text-slate-300">
          {t('routing.recovery.description')}
        </p>
        <button
          type="button"
          onClick={handleReload}
          className="mt-4 inline-flex items-center justify-center rounded-full bg-white px-4 py-2 text-sm font-semibold text-slate-950 transition hover:bg-slate-200"
        >
          {t('routing.recovery.reload')}
        </button>
      </div>
    </div>
  );
}
